import { render, staticRenderFns } from "./popup-layer.vue?vue&type=template&id=1c96cd28&scoped=true"
import script from "./popup-layer.vue?vue&type=script&lang=js"
export * from "./popup-layer.vue?vue&type=script&lang=js"
import style0 from "./popup-layer.vue?vue&type=style&index=0&id=1c96cd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c96cd28",
  null
  
)

export default component.exports